/**
 * Vanila JS variant to jQuery $(() => {}).
 * @param {callback} callback
 * @example - documentReady(() => {}).
 * This function is binding to document.ready
 * */
export function documentReady(callback: () => void) {
    if (document.readyState !== "loading") {
        return callback();
    } else {
        document.addEventListener("DOMContentLoaded", callback);
    }
}
